import { addDoc, collection, doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../firebase/config";
import type { WellnessLog } from "../types/post";

const emptyDayPost = () => ({
  negativeInfluenceLogIDs: [] as string[],
  trainingLogIDs: [] as string[],
  recoveryLogIDs: [] as string[],
  niggleLogIDs: [] as string[],
  performanceLogIDs: [] as string[],
  healthLogIDs: [] as string[],
  stepLogIDs: [] as string[],
  noteLogIDs: [] as string[],
  wellnessLogIDs: [] as string[],
  activityLogIDs: [] as string[],
  femaleCycleLogIDs: [] as string[],
  wearableDayData: [] as string[],
  sessionIDs: [] as string[],
  likes: [] as string[],
  commentIDs: [] as string[],
});

export async function addWellnessLogAndLinkToDayPost(
  userID: string,
  wellnessLog: Omit<WellnessLog, "timestamp" | "dateID">,
  dateID: string,
): Promise<{ wellnessLogId: string }> {
  const docRef = await addDoc(collection(db, "wellnessLogs", userID, "logs"), {
    ...wellnessLog,
    timestamp: Date.now(),
    dateID,
  });

  const dayRef = doc(db, "dayPosts", userID, "posts", dateID);
  const daySnap = await getDoc(dayRef);
  if (daySnap.exists()) {
    const current = (daySnap.data().wellnessLogIDs as string[] | undefined) ?? [];
    if (!current.includes(docRef.id)) {
      await updateDoc(dayRef, { wellnessLogIDs: [...current, docRef.id] });
    }
  } else {
    const created = emptyDayPost();
    created.wellnessLogIDs.push(docRef.id);
    await setDoc(dayRef, created);
  }

  return { wellnessLogId: docRef.id };
}

export async function calculateAndSavePeakScore(dateID: string): Promise<void> {
  const calculate = httpsCallable(functions, "calculateAndSavePeakScore");
  await calculate({ dateID });
}
